export enum LAYOUT_MODES {
  LIGHT = "light",
  DARK = "dark",
}

export enum CHATS_TABS {
  ARCHIVE = "acrhive",
  DEFAULT = "default",
}

export enum TABS {
  NEW_ACCOUNT = "pills-new-account",
  USERS = "pills-user",
  CHAT = "pills-chat",
  CONTACTS = "pills-contacts",
  CALLS = "pills-calls",
  BOOKMARK = "pills-bookmark",
  SETTINGS = "pills-setting",
  PROCESS = "pills-process",
  CONNECTORS = "pills-connectors",
  CONNECTIONS = "pills-connections",
}
